'use client'

// src/index.ts
export * from "./separator";
